/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "thumbs-up-inline-68f1c792--sprite",
  "use": "thumbs-up-inline-68f1c792--sprite-usage",
  "viewBox": "0 0 18 16.579",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16.579\" id=\"thumbs-up-inline-68f1c792--sprite\"><g transform=\"translate(0 6.313)\"><path d=\"M431.257,382.867a3.112,3.112,0,0,0,1.073,2.154l-2.163-.008a2.394,2.394,0,0,1-2.383-2.225l-.355-5.492a2.376,2.376,0,0,1,2.375-2.541l2.392.008a3.147,3.147,0,0,0-1.318,2.809Z\" transform=\"translate(-427.423 -374.755)\" fill=\"currentColor\" /></g><g transform=\"translate(4.19)\"><path d=\"M445.4,376.7l-1.152,6.944a1.645,1.645,0,0,1-1.633,1.381l-8.242-.008A2.379,2.379,0,0,1,432,382.8l-.378-5.294a2.373,2.373,0,0,1,1.238-2.265,2.893,2.893,0,0,1,.379-.166,1.57,1.57,0,0,0,.994-.954l1.728-4.6a1.653,1.653,0,0,1,3.2.569,1.625,1.625,0,0,1-.111.591l-1.088,2.9a.867.867,0,0,0,.82,1.168l4.983.008A1.655,1.655,0,0,1,445.4,376.7Z\" transform=\"translate(-431.613 -368.442)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
